import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { Color } from '../../commun/Constant';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import Label from '../../object/tag/Label';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { JSXInternal } from 'preact/src/jsx';
import { SelectColor } from '../SelectColor';

export interface IAddLabelModalProps extends IBaseModalProps {
    label?: Label;
    baseName?: string;
    onCreate?: (label: Label) => void;
}

export interface IAddLabelModalState {
    name: string;
    color: Color;
    loading: boolean;
    error: string;
}

export default class AddLabelModal extends Component<IAddLabelModalProps, IAddLabelModalState> {
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IAddLabelModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();
    }

    initState() {
        const p: IAddLabelModalState = {
            name: this.props.label?.name.get() ?? this.props.baseName ?? '',
            color: this.props.label?.getColor() ?? 'blue',
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IAddLabelModalProps>,
        prevState: Readonly<IAddLabelModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addVendor() {
        const { name, color } = this.state;
        this.setState({
            loading: true,
            error: '',
        });
        post('/label/update', {
            id: this.props.label?.getAjoIdentifier() ?? '',
            name: name,
            color: color,
        }).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);
                this.props.onClose();

                const p = Label.build();
                Result.applyResult(res, p, true);
                this.props.onCreate?.(p);

                if (this.props.label !== undefined) {
                    AppManager.addToast(new Toast('Le label a été modifié avec succès.', 'success'));
                } else {
                    AppManager.addToast(new Toast('Le label a été ajouté avec succès.', 'success'));
                }
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading, name, error, color } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addVendor();
                }}
                title={this.props.label !== undefined ? 'Modifier un label' : 'Ajouter un label'}
                done={this.props.label !== undefined ? 'Modifier' : 'Ajouter'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-3">
                        <Typography className="!text-sm !font-semibold">NOM DU LABEL</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any).value });
                            }}
                            placeholder="Nom du label"
                            variant="outlined"
                        />
                        <Typography className="!text-sm !font-semibold">COULEUR DU LABEL</Typography>
                        <SelectColor
                            color={color}
                            onSelect={(color) => {
                                this.setState({
                                    color: color,
                                });
                            }}
                        />
                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
